import { HttpContext, HttpContextToken } from '@angular/common/http';

export const COLLECTION_REQUEST_ID = new HttpContextToken<string | null>(
  () => null,
);

export class CollectionRequestContextMissingError extends Error {
  constructor() {
    super('A protected Chordium request requires explicit collection context.');
    this.name = 'CollectionRequestContextMissingError';
  }
}

export function withCollectionRequestContext(
  collectionId: string,
  context: HttpContext = new HttpContext(),
): HttpContext {
  const normalized = collectionId.trim();
  if (!normalized) {
    throw new TypeError('collectionId must be a non-empty string');
  }
  return context.set(COLLECTION_REQUEST_ID, normalized);
}
